export default __webpack_public_path__ + "static/media/Finchley.88833cf7.png";